import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { isTexelAccessFenceEnabled } from '@Services/Texel/TexelAccess';
import TexelBanner from '@Pages/QuickSearch/Components/TexelBanner';
import InfoBar from '../InfoBar';
import BuildQuerySearch from './Components/BuildQuerySearch';
import BuildQueryStructureDrawing from './Components/BuildQueryStructureDrawing';
import BuildQueryHeading from './Components/BuildQueryHeading';

import './BuildQuery.scss';

function BuildQuery(props) {
  const { initialize } = props;
  const showTexelBanner = useMemo(() => isTexelAccessFenceEnabled(), []);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="build-query">
      <section className="build-query__wrapper rx-left-gutter rx-right-gutter " id="main-content">
        <BuildQuerySearch {...props} />
        <div className="build-query__wrapper_separator u-els-font-size-meta">AND</div>
        <BuildQueryStructureDrawing {...props} />
      </section>
      {showTexelBanner ? <TexelBanner /> : null}
      <BuildQueryHeading {...props} />
      <InfoBar />
    </div>
  );
}

BuildQuery.propTypes = {
  initialize: PropTypes.func.isRequired,
};

export default BuildQuery;
